import { simpleSet } from '@r/reducers/utils';

const toggleCalculationModeAccountModal = simpleSet as
  redux.reducers.calculationMode.modals.account;

export const account = toggleCalculationModeAccountModal(
  'TOGGLE_CALCULATION_MODE_ACCOUNT_MODAL',
  false
);
